import { ReactElement } from "react";
import { DialogNavigation } from "../../../modal/Dialog";
import { useFullPageDialogContext } from "../../../modal/useFullPageDialogContext";
import { SharePricingDialogPage } from "./SharePricingDialogTypes";

export function SharePricingDialogNavigation({
  onDismiss,
  priceTierId,
  connectionId,
  priceTierName,
  buyerName,
}: {
  onDismiss: () => void;
  priceTierId?: number;
  connectionId?: number;
  priceTierName?: string;
  buyerName?: string;
}): ReactElement {
  const { page, setPage } = useFullPageDialogContext();
  const initialPage =
    priceTierId || connectionId
      ? SharePricingDialogPage.PRICE_TIER_LINK
      : SharePricingDialogPage.PRICE_TIERS;
  const isInitialPage = page === initialPage;
  const getTitle = () => {
    if (page === SharePricingDialogPage.PRICE_TIER_LINK_DEACTIVATE)
      return `Deactivate link to ${priceTierName}`;
    const mainPageTitle = "Share your pricing and availability";
    if (page === SharePricingDialogPage.PRICE_TIERS) return mainPageTitle;
    if (priceTierName) return `${mainPageTitle}: ${priceTierName}`;
    if (buyerName) return `${mainPageTitle}: ${buyerName}`;

    return mainPageTitle;
  };

  const getDescription = () => {
    if (buyerName && connectionId)
      return `Give ${buyerName} a direct link to see their pricing, including their payment terms and discounts. They will be able to place an order even if they don’t have a Sellar account yet.`;

    return "Gives customers access to see pricing and place orders even if they don't have a Sellar account yet.";
  };
  return (
    <DialogNavigation
      title={getTitle()}
      description={
        page === SharePricingDialogPage.PRICE_TIER_LINK_DEACTIVATE
          ? ""
          : getDescription()
      }
      onClickLeftIcon={() =>
        isInitialPage
          ? onDismiss()
          : setPage(
              page === SharePricingDialogPage.PRICE_TIER_LINK_DEACTIVATE
                ? SharePricingDialogPage.PRICE_TIER_LINK
                : SharePricingDialogPage.PRICE_TIERS,
            )
      }
      leftIcon={isInitialPage ? "CHEVRON_DOWN" : "CHEVRON_LEFT"}
    />
  );
}
